import { Option } from '@eiq/ui';
import { VariableRequiredType } from '@empathy/survey/base';

export const SelectableVariableRequireType: Option<VariableRequiredType>[] = [
  {
    text: 'Required',
    value: 'REQUIRED'
  },
  {
    text: 'Optional',
    value: 'OPTIONAL'
  },
  {
    text: 'Unique',
    value: 'UNIQUE'
  }
];
